import { VersionCheckerTranslations } from '@/assets/locales/components/versionChecker/versionChecker.translations.en.ts';

export const versionCheckerTranslations: VersionCheckerTranslations = {
  newVersionAvailable: 'Dostępna jest nowa wersja aplikacji.',
  refresh: 'Odśwież',
};
